"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APP = exports.CMS_THEME = exports.PACK = exports.CUSTOM_MODULE = exports.COS_TEMPLATE = void 0;
var COS_TEMPLATE = 'COS_TEMPLATE';
exports.COS_TEMPLATE = COS_TEMPLATE;
var CUSTOM_MODULE = 'CUSTOM_MODULE';
exports.CUSTOM_MODULE = CUSTOM_MODULE;
var PACK = 'PACK';
exports.PACK = PACK;
var CMS_THEME = 'CMS_THEME';
exports.CMS_THEME = CMS_THEME;
var APP = 'APP';
exports.APP = APP;